module.exports = __webpack_public_path__ + "img/suspicious-domain.6c9125c7.svg";